// extracted by mini-css-extract-plugin
module.exports = {"heading":"ComponentHeading_heading__DIoCL","noTopMargin":"ComponentHeading_noTopMargin__AUmDc","thin":"ComponentHeading_thin__rFwXo"};